import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="InCha Bishoujo wa, Tannin ni Okasarete mo Ikimakuru parte 1"
      portada="https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_1.jpg"
    paginas={[
  "https://tmohentai.app/storage/mangas/13785/1.webp",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_2.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_3.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_4.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_5.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_6.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_7.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_8.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_9.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_10.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_11.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_12.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_13.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_14.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_15.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_16.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_17.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_18.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_19.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_20.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_21.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_22.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_23.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_24.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_25.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_26.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_27.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_28.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_29.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_30.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_31.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_32.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_33.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_34.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_35.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_36.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_37.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_38.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_39.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_40.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_41.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_42.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_43.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_44.jpg",
  "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_45.jpg"
]}

      sugeridos={[]}


      info={{
  grupo: "aomizuan",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
    etiquetas: ["ahegao", "big ass", "big breasts","big penis","chikan"," fingering"   ," full color hidden sex"," mosaic censorship multi-work series nakadashi"," ponytail"   ," rape" ," schoolgirl uniform"," sole female"," teacher" ," wet clothes" ," x-ray"],
    artistas: "katsurai yoshiaki",
      }}
    />
  );
}

export const infoManga = {
  titulo: "InCha Bishoujo wa, Tannin ni Okasarete mo Ikimakuru parte 1",
  portada: "https://s1.m440.in/uploads/manga/incha-bishoujo-wa-tannin-ni-okasarete-mo-ikimakuru/chapters/0/20540_1.jpg",
  reverso: " ",
   fecha:"2026-05-17",


  info: {
  grupo: "aomizuan",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
    etiquetas: ["ahegao", "big ass", "big breasts","big penis","chikan"," fingering"   ," full color hidden sex"," mosaic censorship multi-work series nakadashi"," ponytail"   ," rape" ," schoolgirl uniform"," sole female"," teacher" ," wet clothes" ," x-ray"],
    artistas: "katsurai yoshiaki",
  },
};
